module.exports = __webpack_public_path__ + "img/2x.5bc732c.jpg";